if (!customElements.get('marquee-text')) {
  customElements.define(
    'marquee-text',
    class MarqueeText extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.closest('.marquee-text');
        if (!this.wrapper) return;

        this.setAttribute('tabindex', '0');
        this.setAttribute('role', 'marquee');
        this.setAttribute('aria-label', 'Scrolling announcements');

        this.addEventListener('click', () => this.togglePause());
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.togglePause();
          }
        });
      }

      togglePause() {
        this.wrapper.classList.toggle('is-paused');
      }
    }
  );
}